import {
  Block,
  BlockOutlined,
  Delete,
  Edit,
  History,
  Link,
  LinkOff,
  LockOpen,
  OutlinedFlag,
} from '@mui/icons-material';
import {
  AccountChangeLogActionType,
  AccountChangeLogType,
} from 'api/user-domain/user-domain.types';
import {
  EventTimelineEntry,
  EventTimelineVisual,
} from 'components/event-timeline/event-timeline.types';

const getActionTypeVisuals = (
  t: (key: string) => string,
): Record<AccountChangeLogActionType, EventTimelineVisual> => ({
  [AccountChangeLogActionType.BLOCKED]: {
    label: t('drawer.blockedAccountDetailsDrawer.timeline.actionTypes.blocked'),
    icon: <Block fontSize="small" />,
    severity: 'error',
  },
  [AccountChangeLogActionType.UNBLOCKED]: {
    label: t(
      'drawer.blockedAccountDetailsDrawer.timeline.actionTypes.unblocked',
    ),
    icon: <LockOpen fontSize="small" />,
    severity: 'success',
  },
  [AccountChangeLogActionType.REOPEN]: {
    label: t(
      'drawer.blockedAccountDetailsDrawer.timeline.actionTypes.reopened',
    ),
    icon: <History fontSize="small" />,
    severity: 'info',
  },
  [AccountChangeLogActionType.LINKED]: {
    label: t('drawer.blockedAccountDetailsDrawer.timeline.actionTypes.linked'),
    icon: <Link fontSize="small" />,
    severity: 'info',
  },
  [AccountChangeLogActionType.UNLINKED]: {
    label: t(
      'drawer.blockedAccountDetailsDrawer.timeline.actionTypes.unlinked',
    ),
    icon: <LinkOff fontSize="small" />,
    severity: 'warning',
  },
  [AccountChangeLogActionType.DELETED]: {
    label: t('drawer.blockedAccountDetailsDrawer.timeline.actionTypes.deleted'),
    icon: <Delete fontSize="small" />,
    severity: 'error',
  },
  [AccountChangeLogActionType.UPDATED]: {
    label: t('drawer.blockedAccountDetailsDrawer.timeline.actionTypes.updated'),
    icon: <Edit fontSize="small" />,
    severity: 'secondary',
  },
  [AccountChangeLogActionType.AUTO_BLOCKED]: {
    label: t(
      'drawer.blockedAccountDetailsDrawer.timeline.actionTypes.autoBlocked',
    ),
    icon: <BlockOutlined fontSize="small" />,
    severity: 'error',
  },
  [AccountChangeLogActionType.AUTO_FLAGGED]: {
    label: t(
      'drawer.blockedAccountDetailsDrawer.timeline.actionTypes.autoFlagged',
    ),
    icon: <OutlinedFlag fontSize="small" />,
    severity: 'warning',
  },
});

export const mapAccountChangeLogsToTimelineEntries = (
  logs: AccountChangeLogType[],
  t: (key: string) => string,
): EventTimelineEntry[] => {
  const visuals = getActionTypeVisuals(t);

  return logs.map((log, index) => ({
    id: index,
    date: log.changedDateTime,
    visual: visuals[log.actionType],
    author: log.adminUserName,
    note: log.description,
  }));
};
